/* eslint-disable react/prop-types */
import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import _ from "lodash";
import getReducedHistorics from "lib/utils/historics";
import CardComponent from "app/common/CardComponent";
import moment from "moment";
import PassthroughChartComponent from "./PassthroughChartComponent";
import ExplicabilityComponent from "../../explicability-info/ExplicabilityComponent";

const useStyles = makeStyles((theme) => ({
  aggregateContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: "5px",
  },
  chartContainer: {
    position: "relative",
    overflow: "hidden",
    flexGrow: "1",
    [theme.breakpoints.up("xs")]: {
      height: "155px",
    },
    [theme.breakpoints.up("sm")]: {
      height: "200px",
    },
    [theme.breakpoints.up("md")]: {
      height: "300px",
    },
    [theme.breakpoints.up("lg")]: {
      height: "100%",
    },
  },
  componentTitle: {
    fontWeight: "bold",
    fontSize: "14px",
    [theme.breakpoints.up("xl")]: {
      fontSize: "16px",
    },
  },
}));

function HistoryPassthroughComponent({ historics, historicsDataYoY }) {
  const classes = useStyles();
  const metadataSlice = useSelector((state) => state.metadata);

  const reducedFilteredHistorics = getReducedHistorics(historics);

  const passthroughData = {
    labels: _.map(historics, (historic) => {
      return moment(historic.date).format("MMM'YY");
    }),
    datasets: [
      {
        label: "Price Out",
        type: "line",
        fill: false,
        borderColor: "#FBB03B",
        pointBordercolor: "#FBB03B",
        pointBackgroundColor: "#ffffff",
        backgroundColor: "#FBB03B",
        pointHoverBackgroundColor: "#ffffff",
        hoverBorderWidth: 3,
        pointHoverRadius: 6,
        data: _.map(historics, (historic) => {
          return {
            ...historic,
            title: `Date: ${moment(historic.date).format("MMM'YY")}`,
            unit: metadataSlice.all.margin[0].unit,
            x: moment(historic.date).format("MMM'YY"),
            y: historic.avg_weight_by_units_price,
            price: {
              absolute: historic.avg_weight_by_units_price,
            },
            price_in: {
              absolute: historic.avg_weight_by_units_price_in,
            },
            cost: {
              absolute: historic.avg_weight_by_units_cost,
            },
          };
        }),
      },
      {
        label: "Price In",
        type: "line",
        fill: false,
        borderColor: "#A2670A",
        pointBordercolor: "#A2670A",
        pointBackgroundColor: "#ffffff",
        backgroundColor: "#A2670A",
        borderDash: [5, 5],
        pointHoverBackgroundColor: "#ffffff",
        hoverBorderWidth: 3,
        pointHoverRadius: 6,
        data: _.map(historics, (historic) => {
          return {
            ...historic,
            title: `Date: ${moment(historic.date).format("MMM'YY")}`,
            x: moment(historic.date).format("MMM'YY"),
            y: historic.avg_weight_by_units_price_in,
            price: {
              absolute: historic.avg_weight_by_units_price,
            },
            price_in: {
              absolute: historic.avg_weight_by_units_price_in,
            },
            cost: {
              absolute: historic.avg_weight_by_units_cost,
            },
          };
        }),
      },
      {
        label: "Cost",
        type: "bar",
        borderColor: "#FEE7C4",
        pointBordercolor: "#FEE7C4",
        pointBackgroundColor: "#ffffff",
        backgroundColor: "#FEE7C4",
        data: _.map(historics, (historic) => {
          return {
            ...historic,
            title: `Date: ${moment(historic.date).format("MMM'YY")}`,
            unit: metadataSlice.all.margin[0].unit,
            x: moment(historic.date).format("MMM'YY"),
            y: historic.avg_weight_by_units_cost,
            price: {
              absolute: historic.avg_weight_by_units_price,
            },
            price_in: {
              absolute: historic.avg_weight_by_units_price_in,
            },
            cost: {
              absolute: historic.avg_weight_by_units_cost,
            },
          };
        }),
      },
    ],
  };

  return (
    <CardComponent
      title={
        <>
          <Typography variant="body1" className={classes.componentTitle}>
            {`Passthrough & Cost (${metadataSlice.all.margin[0].unit})`}
            <ExplicabilityComponent tooltipText="Historical values for prices and costs in the last 12 months" />
          </Typography>
          {reducedFilteredHistorics.promotions && (
            <div className={classes.aggregateContainer}>
              <Typography variant="caption">
                Followed Price Changes
                <ExplicabilityComponent tooltipText="Discover how often CPG price changes have been followed by Retailers" />
              </Typography>
              <Typography
                variant="subtitle2"
                style={{
                  fontWeight: "bold",
                  marginLeft: "10px",
                }}
              >
                {(
                  (100 * reducedFilteredHistorics.followed_promotions) /
                  reducedFilteredHistorics.promotions
                ).toFixed(1)}
                %
              </Typography>
            </div>
          )}
        </>
      }
      body={
        <div className={classes.chartContainer}>
          <PassthroughChartComponent
            data={passthroughData}
            historicsDataYoY={historicsDataYoY}
          />
        </div>
      }
    />
  );
}

export default HistoryPassthroughComponent;
